const About = ({ data }) => (
  <section id="about" className="container pb6 tc mid-gray">
    <h2 className="heading mb4 pb3 purple">{data.heading}</h2>
    <Stories
      synopsis={data.synopsis}
      background={data.background}
      image={data.image.childImageSharp.sizes}
    />
  </section>
)
export default About

/*
 *
 * General
 * 
 */

import React from 'react'

/*
 *
 * Stories
 * 
 */

import Img from '../components/base/Img'

class Stories extends React.Component {
  state = { activeCategory: `Synopsis`, limit: 3 }

  handleFilterClick = event => {
    if (this.state.activeCategory !== event.target.innerHTML) {
      this.setState({ activeCategory: event.target.innerHTML })
    }
  }

  handleReadMore = () => {
    if (this.state.limit < 99) {
      this.setState({ limit: 99 })
    }
  }

  render() {
    const { synopsis, background } = this.props
    const { activeCategory, limit } = this.state

    const limited = activeCategory === `Background` && limit < 99
    const paragraphs = activeCategory === `Synopsis` ? synopsis : background

    return (
      <div>
        <Filters category={activeCategory} handleClick={this.handleFilterClick} />
        <Paragraphs paragraphs={paragraphs.slice(0, limit)} />
        {limited && (
          <button
            type="button"
            onClick={this.handleReadMore}
            className="mt3 f4 ttu purple animate hover:mid-gray"
          >
            Read More
          </button>
        )}
        <Img sizes={this.props.image} alt="" className="ml-auto mr-auto mt4 w3" />
      </div>
    )
  }
}

/*
 *
 * Filters
 * 
 */

const Filters = ({ category, handleClick }) => (
  <div className="mb4">
    <button
      onClick={handleClick}
      className={`filter-btn mb3` + (category === `Synopsis` ? ` active` : ``)}
    >
      Synopsis
    </button>
    <button
      onClick={handleClick}
      className={`filter-btn mb3` + (category === `Background` ? ` active` : ``)}
    >
      Background
    </button>
  </div>
)

/*
 *
 * Paragraphs
 * 
 */

import shortid from 'shortid'

import Reveal from '../components/Reveal'

const Paragraphs = ({ paragraphs }) => (
  <Reveal
    css={{ opacity: 0, transform: `translateY(40px) scale(.8)` }}
    duration={1}
    offsetTop={-100}
  >
    {paragraphs.map(paragraph => {
      return (
        <p
          key={shortid.generate()}
          dangerouslySetInnerHTML={{ __html: paragraph }}
          className="mb3 ml-auto mr-auto measure lh-copy abeezee"
        />
      )
    })}
  </Reveal>
)



// WEBPACK FOOTER //
// ./src/sections/About.js